export default "__VITE_ASSET__DmVQnwHY__"